import { render, staticRenderFns } from "./UsuarioDataAlteracaoDialog.vue?vue&type=template&id=141a9980"
import script from "./UsuarioDataAlteracaoDialog.vue?vue&type=script&lang=js"
export * from "./UsuarioDataAlteracaoDialog.vue?vue&type=script&lang=js"
import style0 from "./UsuarioDataAlteracaoDialog.vue?vue&type=style&index=0&id=141a9980&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports